import { useState, useEffect, useRef } from 'react';
import styles from '../css/ConnectFour.module.css'

import redPiece from "../data/images/redPiece_2.png" // Shark
import yellowPiece from "../data/images/yellowPiece_2.png" // Shell

import { useLocation } from "react-router-dom"

async function CallAPI(url, body) {

  if (!body) {
    body = {
      credentials: "include"
    }
  }
  else {
    body.credentials = "include"
  }

  const response = await fetch(
    `https://anagrams.ca/api/${url}`,
    body
  );

  return response
}


export default function ConnectFour(props) {
  const [turn, setTurn] = useState(1);
  const [board, setBoard] = useState([
    [0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0],
  ]);

  const location = useLocation()

  const [redPlayer, setRedPlayer] = useState(null)
  const [yellowPlayer, setYellowPlayer] = useState(null)
  const [isHost, setIsHost] = useState(false)
  const [gameId, setGameId] = useState("")
  const [gameState, setGameState] = useState(0)
  const [playerCount, setPlayerCount] = useState(1)
  const [lastPiece, setLastPiece] = useState(-1);
  const username = location.state.username

  const winnerDeclared = useRef(false)

  useEffect(() => {

    async function getGameDetails() {
      console.log(`State`)
      console.log(location.state)
      const response = await CallAPI(`connect/find?game_id=${location.state.gameId}`);
      const data = await response.json()


      const game = data;
      console.log(game)
      setRedPlayer(game.players.red)
      setYellowPlayer(game.players.yellow)
      const isHost = game.host == location.state.username
      setIsHost(isHost)
      setPlayerCount(game.players.list.length)
      setGameId(game.game_id)
      setGameState(game.gameState)
      setBoard(prevBoard => {
      
        const diff = findDifference(game.boardState, prevBoard);
      
        if (diff) {
          console.log(diff);
      
          const lastIndex = diff.row * 7 + diff.col;
          setLastPiece(lastIndex);
        }
      
        return game.boardState;
      });
      setTurn(game.turn)
    }
    getGameDetails()
  }, [location.state.gameId]);

  useEffect(() => {
    async function updateGame() {

      const response = await CallAPI(`connect/find?game_id=${location.state.gameId}`);
      console.log(response)
      const data = await response.json()

      const game = data;
      
      setRedPlayer(game.players.red)
      setYellowPlayer(game.players.yellow)
      setPlayerCount(game.players.list.length)
      setGameState(game.gameState)
      
      setBoard(prevBoard => {
      
        const diff = findDifference(game.boardState, prevBoard);
      
        if (diff) {
          console.log(diff);
      
          const lastIndex = diff.row * 7 + diff.col;
          setLastPiece(lastIndex);
        }
      
        return game.boardState;
      });
      
      setTurn(game.turn)

      if (game.gameState == 2 && !winnerDeclared.current) {
        winnerDeclared.current = true;
        return alert(`Winner: ${game.winner == 1 ? game.players.red : game.players.yellow}`)

      }
    }

    updateGame()
    const interval = setInterval(updateGame, 500);

    return () => clearInterval(interval)
  }, [location.state.gameId]);

  function findDifference(arr1, arr2) {
    for (let row = 0; row < arr1.length; row++) {
      for (let col = 0; col < arr1[row].length; col++) {
        if (arr1[row][col] !== arr2[row][col]) {
          return { row, col };
        }
      }
    }

    return null; // no differences
  }
  function startGame() {

    async function StartNewGame() {

      console.log(`Starting game`)
      const response = await CallAPI(`connect/${gameId}/start?username=${username}`, {
        method: "POST"
      });

      const data = await response.json();
      console.log(data)

      if (data['error']) {

        return alert(data['errorr']);
      }
      const game = data;

      setRedPlayer(game.players.red)
      setYellowPlayer(game.players.yellow)
      setTurn(game.turn)
     setBoard(prevBoard => {

      const diff = findDifference(game.boardState, prevBoard);
    
      if (diff) {
        setLastPiece(diff.row * 7 + diff.col);
      }
    
      return game.boardState;
    });
    
    setTurn(game.turn);

    }

    StartNewGame();

  }


  async function placePiece(row, col) {

    if (gameState != 1) {
      return
    }
    if (!checkValidPlacement(row, col)) {
      return;
    }

    const response = await CallAPI(`connect/${gameId}/place?username=${username}&row=${row}&col=${col}`, {
      method: "POST"
    });

    const data = await response.json();
    if (data['error']) {
      return alert(data['error']);
    }
    const game = data;
    console.log(game);

    setTurn(game.turn)
    setBoard(prevBoard => {
    
      const diff = findDifference(game.boardState, prevBoard);
    
      if (diff) {
        setLastPiece(diff.row * 7 + diff.col);
      }
    
      return game.boardState;
    });

setTurn(game.turn);
    return

  }
  return (
    <>
      <div className={styles.info}>
        <span className={styles.gameId}>{gameId}</span>
        {gameState === 0 && <span className={styles.playerlist}>Players: {playerCount} / 2</span>}
        {gameState === 1 && <span className={styles.playerlist}>Shark: {redPlayer} | Shell: {yellowPlayer}</span>}
      </div>

      <div className={gameState === 0 ? `${styles.gameBody} ${styles.gameBodyStart}` : styles.gameBody}>
        <div className={styles.turnInfo}>
          {gameState === 1 &&
            <span className={`${styles.turn} ${turn == 2 ? styles.yellow : styles.red
              }`}
            >
              {turn == 2 ? 'shell' : 'shark'}'s turn
            </span>

          }
        </div>
        <div className={styles.buttons} >
          {gameState === 0 && <StartGame callback={startGame} />}
          {gameState === 2 && <DeleteGame />}
        </div>
        {gameState === 0 &&
          
            <img src={redPiece} alt="Red Piece" className={styles.redStartImage} />
          
        }
        <div className={gameState === 0 ? `${styles.board} ${styles.boardStart}` : styles.board}>
          <SetBoard board={board} callback={placePiece} lastPiece={lastPiece} />
        </div>
        {gameState === 0 &&
          
            <img src={yellowPiece} alt="Yellow Piece" className={styles.yellowStartImage} />
          
        }

      </div>
    </>
  );
  function checkValidPlacement(row, col) {
    if (board[row][col] != 0) {
      return false;
    }
    console.log(row);
    // Check all tiles below, ensure they are not 0;

    for (let i = row + 1; i < 6; i++) {
      const place = board[i][col];

      if (place == 0) {
        return false;
      }
    }

    return true;
  }


}

function SetBoard({ board, callback, lastPiece }) {


  return (
    <>
      {board.flat().map((cell, index) => (
        <button
          key={index}
          className={styles.cell}
          onClick={() => callback(Math.floor(index / 7), index % 7)}
        >
          {cell === 1 && (
            <img
              src={redPiece}
              alt="Red Piece"
              className={lastPiece == index ? `${styles.piece} ${styles.lastPieceRed}` : styles.piece}
            />
          )}
          {cell === 2 && (
            <img
              src={yellowPiece}
              alt="Yellow Piece"
              className={lastPiece == index ? `${styles.piece} ${styles.lastPieceYellow}` : styles.piece}
            />
          )}
        </button>
      ))}
    </>
  );
}

function StartGame({ callback }) {
  return (
    <button
      className={styles.start}
      onClick={callback}
    >
      Start
    </button>
  )
}

function DeleteGame({ }) {
  return (
    <button
      className={styles.delete}
      onClick={console.log('Game Deleted.. Jk')}
    >
      Delete Lobby
    </button>
  )

}


